export { ConnectPartner as default } from "./connect-partner";
